<template>
    <div>
        <div class="smallContent miscContent">
            <p v-if="!sent">Please enter your email</p>

            <form @submit.prevent="reset" v-if="!sent">
                <input type="email" v-model="email" placeholder="Email" /><br />
                <input type="submit" value="Reset Password" />
            </form>
            <p v-if="message" id="message">{{ message }}</p>
            <img
                v-if="loading"
                id="spinner"
                src="/static/icons/spinner-big.svg"
                alt=""
            />
            <p v-if="hash">
                <a :href="'#/create-password/' + hash">Create new Password</a>
            </p>
        </div>

        <Footer></Footer>
    </div>
</template>

<script>
import axios from "axios";
import { store } from "../store";
import Footer from "./Footer.vue";

export default {
    name: "ResetPW",
    components: {
        Footer,
    },
    data() {
        return {
            email: "",
            store: store,
            hash: "",
            message: "",
            loading: false,
            sent: false,
        };
    },
    methods: {
        getCookie(cname) {
            var name = cname + "=";
            var decodedCookie = decodeURIComponent(document.cookie);
            var ca = decodedCookie.split(";");
            for (var i = 0; i < ca.length; i++) {
                var c = ca[i];
                while (c.charAt(0) == " ") {
                    c = c.substring(1);
                }
                if (c.indexOf(name) == 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return "";
        },
        reset() {
            let myself = this;
            myself.message = "";
            myself.loading = true;
            axios.defaults.headers.common["X-CSRFToken"] =
                this.getCookie("csrftoken");
            axios
                .post("/api/reset-password", { email: this.email })
                .then((response) => {
                    if (response.data.detail == "Success") {
                        //localStorage.setItem("authenticated", "success");
                        //myself.store.authenticated = true;
                        //myself.hash = response.data.hash;
                        myself.message = response.data.message;
                    } else if (response.data.detail == "Error") {
                        myself.message = response.data.message;
                    }
                    myself.loading = false;
                    myself.sent = true;
                });
        },
    },
    created() {
        axios.get("/api/login-set-cookie");
    },
    activated() {
        this.message = "";
        this.sent = false;
    },
};
</script>

<style scoped>
.miscContent {
    width: min(550px, 100%);
}
p {
    margin-bottom: 0.8rem;
    margin-top: 0;
}
#message {
    margin-top: 0.8rem;
    color: red;
}
@keyframes spin {
    100% {
        transform: rotate(360deg);
    }
}
#spinner {
    margin: 1rem calc(50% - 1rem);
    max-height: 3rem;
    animation: spin 1s linear infinite;
}
</style>
